export default {
    install: function (Vue) {
        Vue.filter('toCurrency', (value) => {
            if (isNaN(parseFloat(value))) {
                value = 0;
            }
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2
            });
            return formatter.format(parseFloat(value));
        });
        Vue.filter('toNumber', (value) => {
            if (isNaN(parseFloat(value))) {
                return 0;
            }

            // preserve any suffixes
            let suffix = value.match(/\d+(\D+)/);
            if (suffix !== null) {
                suffix = suffix[1];
            } else {
                suffix = '';
            }

            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'decimal',
                minimumFractionDigits: 0
            });
            return formatter.format(parseFloat(value)) + suffix;
        });
    }
};